import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PulangApsSvc from "@/services/pulangApsService";

@Module({ store, dynamic: true, namespaced: true, name: "pulang-aps" })
class PulangApsModule extends VuexModule {
  currentItem: any = null;
  loading = false;

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await PulangApsSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data || null);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_CURRENT_ITEM(null);
  }
}

export const storePulangAps = getModule(PulangApsModule);
